import React, { useRef, useEffect } from 'react';

function AutoResizeTextarea({ value, onChange, onBlur, ...props }) {
  const textareaRef = useRef();

  const autoResize = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = '1px';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  };

  const handleChange = (e) => {
    if (onChange) onChange(e);   // викликаємо зовнішній onChange
    autoResize();
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e);       // викликаємо зовнішній onBlur
  };

  useEffect(() => {
    autoResize(); // ініціалізація при першому рендері
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      style={{
        minWidth: 'calc(100% - 32px)',
        minHeight: '14px',
        resize: 'none',
        overflow: 'hidden',
        height: '14px'
      }}
      {...props}
    />
  );
}

export default AutoResizeTextarea;
